import type { FC, HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

type TEyebrowProps = HTMLAttributes<HTMLParagraphElement>;

const Eyebrow: FC<TEyebrowProps> = ({ className, ...rest }) => (
  <p className={cn('text-eyebrow text-text-muted uppercase', className)} {...rest} />
);

export type {
  TEyebrowProps,
};
export {
  Eyebrow,
};
